// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsDynamicTcaReport_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7 4H17V6H7V4ZM13 8H7V10H13V8ZM12 19.5C12 20.3284 11.3284 21 10.5 21 9.67157 21 9 20.3284 9 19.5 9 18.6716 9.67157 18 10.5 18 11.3284 18 12 18.6716 12 19.5ZM14.5 18C15.3284 18 16 17.3284 16 16.5 16 15.6716 15.3284 15 14.5 15 13.6716 15 13 15.6716 13 16.5 13 17.3284 13.6716 18 14.5 18ZM12 14.5C12 15.3284 11.3284 16 10.5 16 9.67157 16 9 15.3284 9 14.5 9 13.6716 9.67157 13 10.5 13 11.3284 13 12 13.6716 12 14.5ZM16.5 12C17.3284 12 18 11.3284 18 10.5 18 9.67157 17.3284 9 16.5 9 15.6716 9 15 9.67157 15 10.5 15 11.3284 15.6716 12 16.5 12Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M3 24V0H21V24H3ZM5.00006 2L19 2L19 22L6.91465 22C6.96992 21.8436 7 21.6753 7 21.5C7 20.6716 6.32843 20 5.5 20C5.32471 20 5.15643 20.0301 5.00006 20.0853V17.9147C5.15643 17.9699 5.32471 18 5.5 18C6.32843 18 7 17.3284 7 16.5C7 15.6716 6.32843 15 5.5 15C5.32471 15 5.15643 15.0301 5.00006 15.0853L5.00006 2Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsDynamicTcaReport is a generated icon component.
 */
let IconRmsDynamicTcaReport = IconRmsDynamicTcaReport_1 = class IconRmsDynamicTcaReport extends IconBaseElement {
    render() {
        return html `${IconRmsDynamicTcaReport_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsDynamicTcaReport.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconRmsDynamicTcaReport = IconRmsDynamicTcaReport_1 = __decorate([
    customElement('zui-icon-rms-dynamic-tca-report')
], IconRmsDynamicTcaReport);
export { IconRmsDynamicTcaReport };
